import React from 'react'
import PropTypes from 'prop-types'
import { PeopleSelect } from 'containers'
import { Title } from 'components/atoms'
import { Modal } from 'components/molecules'

const PeopleSelectModal = ({
  subweb, pageId, isOpen, toggle, onSelect
}) => {
  const handleSelect = (selectedPerson) => {
    onSelect(selectedPerson)
    if (isOpen) toggle()
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <Modal.Top>
        <Title>
          Selecionar utilizador
        </Title>
      </Modal.Top>
      <PeopleSelect subweb={subweb} pageId={pageId} onSelect={handleSelect} />
    </Modal>
  )
}

PeopleSelectModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  onSelect: PropTypes.func,
  subweb: PropTypes.string.isRequired,
  pageId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

PeopleSelectModal.defaultProps = {
  toggle: () => null,
  isOpen: false,
  onSelect: () => null,
  pageId: undefined,
}

export default PeopleSelectModal
